export const SekansSoundsIdentifier = props => {
  const cursorPosition = props.cursorPosition
  const cursorY = cursorPosition[0]
  const cursorX = cursorPosition[1]
  let stepsLeft = parseInt((cursorX + 1) / 4) + 1
  let stepsRight = ((cursorX + 1) % 4)
  if (stepsRight === 0) {
    stepsRight = 4
    stepsLeft--
  }    

  const currentSoundImg = props.soundsIdentifiersImages[cursorY]

  const currentPadActivate = props.activePads[cursorY][cursorX]

  const cursorPadActivateSrc = currentPadActivate ? props.cursorPadActiveImages[1] : props.cursorPadActiveImages[0]

  return (
    <div className="sekansIdentifiersContainer">
      <div className="sekansSoundIdentifierContainer pointerHover" onClick={props.handleClick} data-action="playCurrentSound" title="Q"> 
        <img draggable="false" className="sekansSoundIdentifierImg noContextMenu" src={currentSoundImg} alt="soundIdentifierImg" />
      </div>
      <div className="sekansCursorIdentifiersContainer">
        <div className="sekansCursorPositionIdentifierContainer">
          <div className="sekansStepPositionDisplay">
            {stepsLeft}
          </div>
          <div className="sekansStepPositionDisplayInBetween">
            : 
          </div>
          <div className="sekansStepPositionDisplay">
            {stepsRight}
          </div>  
        </div>
        <div className="sekansCursorActivateIdentifierContainer">
          <img draggable="false" className="sekansCursorActivateImg noContextMenu" src={cursorPadActivateSrc} alt="x or o" />
        </div>
      </div>
    </div>
  )
}